export const isAppRatingAvailable = (): boolean => {
  return (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers["app-rating-request"]
  );
};

// Function to request app rating from the iOS system
export const requestAppRating = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (isAppRatingAvailable()) {
      // Since app rating doesn't return a response, we just resolve immediately after sending
      try {
        window.webkit.messageHandlers["app-rating-request"].postMessage(
          "app-rating-request"
        );
        resolve();
      } catch (error) {
        reject("Failed to request app rating");
      }
    } else {
      reject("iOS app rating capability not available");
    }
  });
};
